import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Tailwind CSS",
  "description": "Learn how to use Tailwind CSS in a Turborepo."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Tailwind CSS is a CSS framework that allows you to rapidly build modern websites without ever leaving your HTML."
  }, {
    "heading": "quickstart",
    "content": "If you'd rather use a template, this guide is walking throw how to build this Tailwind CSS + Turborepo template."
  }, {
    "heading": "create-a-monorepo",
    "content": "If you don't have an existing project, use create-turbo to create a new monorepo:"
  }, {
    "heading": "add-tailwind-css-to-your-application",
    "content": "Follow Tailwind CSS's guides to set up Tailwind CSS for your frontend framework."
  }, {
    "heading": "add-tailwind-css-to-your-application",
    "content": "Once completed, you can start working on bringing your UI package into the applications."
  }, {
    "heading": "create-a-shared-tailwind-css-configuration-package",
    "content": "First, build an Internal Package with four files:"
  }, {
    "heading": "create-a-shared-tailwind-css-configuration-package",
    "content": "This package.json installs Tailwind CSS so we can create the file shared styles and export for the rest of the repository."
  }, {
    "heading": "create-a-shared-tailwind-css-configuration-package",
    "content": "This shared-styles.css file will be shared to the libraries and applications in the repository. The variables shown will be available anywhere that the file is included."
  }, {
    "heading": "create-a-shared-tailwind-css-configuration-package",
    "content": "If your frontends need a PostCSS configuration file, you can create one to share."
  }, {
    "heading": "create-the-ui-package",
    "content": "You can now build the components to share to your applications."
  }, {
    "heading": "create-the-ui-package",
    "content": "For a full example, visit the source code for @repo/ui package in the Tailwind CSS example. The files required for your Tailwind CSS setup are below."
  }, {
    "heading": "create-the-ui-package",
    "content": "The package.json installs the dependencies for the package, sets up scripts for development and build environments, and marks the exports for the package."
  }, {
    "heading": "create-the-ui-package",
    "content": "Above, we've only included the code related to setting up Tailwind. The full\npackage.json is\nhere."
  }, {
    "heading": "create-the-ui-package",
    "content": "Create a build and dev task that runs the scripts for building of components and style sheets in parallel."
  }, {
    "heading": "create-the-ui-package",
    "content": "This styles.css contains component-level styles for the shared UI library."
  }, {
    "heading": "create-the-ui-package",
    "content": "Do not import Tailwind CSS here. It should only be imported by the consuming\napplication to avoid style duplication issues."
  }, {
    "heading": "use-the-ui-package-in-an-application",
    "content": "Install the packages you've created into your application."
  }, {
    "heading": "use-the-ui-package-in-an-application",
    "content": "Then, configure the files in your application so the styles from the UI package are reflected in the application."
  }],
  "headings": [{
    "id": "quickstart",
    "content": "Quickstart"
  }, {
    "id": "guide",
    "content": "Guide"
  }, {
    "id": "create-a-monorepo",
    "content": "Create a monorepo"
  }, {
    "id": "add-tailwind-css-to-your-application",
    "content": "Add Tailwind CSS to your application"
  }, {
    "id": "create-a-shared-tailwind-css-configuration-package",
    "content": "Create a shared Tailwind CSS configuration package"
  }, {
    "id": "create-the-ui-package",
    "content": "Create the UI package"
  }, {
    "id": "use-the-ui-package-in-an-application",
    "content": "Use the UI package in an application"
  }]
};
import {PackageManagerTabs, Tabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
export const toc = [{
  depth: 2,
  url: "#quickstart",
  title: _jsx(_Fragment, {
    children: "Quickstart"
  })
}, {
  depth: 2,
  url: "#guide",
  title: _jsx(_Fragment, {
    children: "Guide"
  })
}, {
  depth: 3,
  url: "#create-a-monorepo",
  title: _jsx(_Fragment, {
    children: "Create a monorepo"
  })
}, {
  depth: 3,
  url: "#add-tailwind-css-to-your-application",
  title: _jsx(_Fragment, {
    children: "Add Tailwind CSS to your application"
  })
}, {
  depth: 3,
  url: "#create-a-shared-tailwind-css-configuration-package",
  title: _jsx(_Fragment, {
    children: "Create a shared Tailwind CSS configuration package"
  })
}, {
  depth: 3,
  url: "#create-the-ui-package",
  title: _jsx(_Fragment, {
    children: "Create the UI package"
  })
}, {
  depth: 3,
  url: "#use-the-ui-package-in-an-application",
  title: _jsx(_Fragment, {
    children: "Use the UI package in an application"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://tailwindcss.com/",
        children: "Tailwind CSS"
      }), " is a CSS framework that allows you to rapidly build modern websites without ever leaving your HTML."]
    }), "\n", _jsx(_components.h2, {
      id: "quickstart",
      children: "Quickstart"
    }), "\n", _jsxs(_components.p, {
      children: ["If you'd rather use a template, this guide is walking throw how to build ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/with-tailwind",
        children: "this Tailwind CSS + Turborepo template"
      }), "."]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-tailwind"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-tailwind"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-tailwind"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " with-tailwind"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "guide",
      children: "Guide"
    }), "\n", _jsx(Callout, {
      type: "info",
      children: "This guide is for Tailwind CSS v4."
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "create-a-monorepo",
          children: "Create a monorepo"
        }), _jsxs(_components.p, {
          children: ["If you don't have an existing project, use ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "create-turbo"
          }), " to create a new monorepo:"]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " dlx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bunx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " create-turbo@latest"
                    })]
                  })
                })
              })
            })
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "add-tailwind-css-to-your-application",
          children: "Add Tailwind CSS to your application"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://tailwindcss.com/docs/installation/using-vite",
            children: "Follow Tailwind CSS's guides"
          }), " to set up Tailwind CSS for your frontend framework."]
        }), _jsx(_components.p, {
          children: "Once completed, you can start working on bringing your UI package into the applications."
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "create-a-shared-tailwind-css-configuration-package",
          children: "Create a shared Tailwind CSS configuration package"
        }), _jsxs(_components.p, {
          children: ["First, build an ", _jsx(_components.a, {
            href: "https://turborepo.com/docs/core-concepts/internal-packages",
            children: "Internal Package"
          }), " with four files:"]
        }), _jsxs(Tabs, {
          items: ["package.json", "shared-styles.css", "postcss.config.js (Optional)"],
          children: [_jsxs(Tab, {
            value: "package.json",
            children: [_jsxs(_components.p, {
              children: ["This ", _jsx(_components.code, {
                children: "package.json"
              }), " installs Tailwind CSS so we can create the file shared styles and export for the rest of the repository."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/tailwind-config/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"name\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"@repo/tailwind-config\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"version\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"0.0.0\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"type\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"module\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"private\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"exports\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \".\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./shared-styles.css\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./postcss\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./postcss.config.js\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"devDependencies\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"postcss\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"^8.5.3\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"tailwindcss\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"^4.1.5\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "shared-styles.css",
            children: [_jsxs(_components.p, {
              children: ["This ", _jsx(_components.code, {
                children: "shared-styles.css"
              }), " file will be shared to the libraries and applications in the repository. The variables shown will be available anywhere that the file is included."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/tailwind-config/shared-styles.css",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "@import"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " 'tailwindcss'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ";"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: " "
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "@theme"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  --blue-1000: #2a8af6;"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  --purple-1000: #a853ba;"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  --red-1000: #e92a67;"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "postcss.config.js (Optional)",
            children: [_jsx(_components.p, {
              children: "If your frontends need a PostCSS configuration file, you can create one to share."
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/tailwind-config/postcss.config.js",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "export"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " const"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " postcssConfig"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " ="
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  plugins"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    '@tailwindcss/postcss'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {}"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "};"
                    })
                  })]
                })
              })
            })]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "create-the-ui-package",
          children: "Create the UI package"
        }), _jsx(_components.p, {
          children: "You can now build the components to share to your applications."
        }), _jsxs(_components.p, {
          children: ["For a full example, ", _jsxs(_components.a, {
            href: "https://github.com/vercel/turborepo/tree/main/examples/with-tailwind/packages/ui",
            children: ["visit the source code for ", _jsx(_components.code, {
              children: "@repo/ui"
            }), " package in the Tailwind CSS example"]
          }), ". The files required for your Tailwind CSS setup are below."]
        }), _jsxs(Tabs, {
          items: ["package.json", "turbo.json", "styles.css"],
          children: [_jsxs(Tab, {
            value: "package.json",
            children: [_jsxs(_components.p, {
              children: ["The ", _jsx(_components.code, {
                children: "package.json"
              }), " installs the dependencies for the package, sets up scripts for development and build environments, and marks the exports for the package."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/ui/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"exports\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./styles.css\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/index.css\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/*.js\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build:styles\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tailwindcss -i ./src/styles.css -o ./dist/index.css\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build:components\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev:styles\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tailwindcss -i ./src/styles.css -o ./dist/index.css --watch\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev:components\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --watch\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"devDependencies\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@repo/tailwind-config\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"workspace:*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@tailwindcss/cli\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"^4.1.5\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@tailwindcss/postcss\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"^4.1.5\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"autoprefixer\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"^10.4.20\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"tailwindcss\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"^4.1.5\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(Callout, {
              type: "good-to-know",
              children: _jsxs(_components.p, {
                children: ["Above, we've only included the code related to setting up Tailwind. The full\npackage.json is\n", _jsx(_components.a, {
                  href: "https://github.com/vercel/turborepo/tree/main/examples/with-tailwind/packages/ui/package.json",
                  children: "here"
                }), "."]
              })
            })]
          }), _jsxs(Tab, {
            value: "turbo.json",
            children: [_jsxs(_components.p, {
              children: ["Create a ", _jsx(_components.code, {
                children: "build"
              }), " and ", _jsx(_components.code, {
                children: "dev"
              }), " task that runs the scripts for building of components and style sheets in parallel."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/ui/turbo.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"extends\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"//\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"tasks\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"build:styles\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"build:components\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build:styles\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"outputs\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"dist/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build:components\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"outputs\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"dist/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"with\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"dev:styles\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"dev:components\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev:styles\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"cache\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " false"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"persistent\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev:components\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"cache\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " false"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"persistent\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "styles.css",
            children: [_jsxs(_components.p, {
              children: ["This ", _jsx(_components.code, {
                children: "styles.css"
              }), " contains component-level styles for the shared UI library."]
            }), _jsx(Callout, {
              type: "info",
              children: _jsx(_components.p, {
                children: "Do not import Tailwind CSS here. It should only be imported by the consuming\napplication to avoid style duplication issues."
              })
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/ui/src/styles.css",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "/* Component-level styles for the UI package */"
                    })
                  })
                })
              })
            })]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "use-the-ui-package-in-an-application",
          children: "Use the UI package in an application"
        }), _jsx(_components.p, {
          children: "Install the packages you've created into your application."
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/tailwind-config"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=web"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " workspace"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " web"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/tailwind-config"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " workspace"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/tailwind-config"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/tailwind-config"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace=web"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " @repo/tailwind-config"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=@repo/ui"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --filter=web"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsx(_components.p, {
          children: "Then, configure the files in your application so the styles from the UI package are reflected in the application."
        }), _jsxs(Tabs, {
          items: ["globals.css", "postcss.config.js (Optional)"],
          children: [_jsx(Tab, {
            value: "globals.css",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./apps/web/app/globals.css",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "@import"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " 'tailwindcss'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ";"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "@import"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " '@repo/tailwind-config'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ";"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "@import"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " '@repo/ui/styles.css'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ";"
                    })]
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "postcss.config.js (Optional)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./apps/web/postcss.config.js",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "import"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " { postcssConfig } "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "from"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " '@repo/tailwind-config/postcss'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ";"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: " "
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "export"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " default"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " postcssConfig;"
                    })]
                  })]
                })
              })
            })
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
